import { HOST_SECOND } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
import compareVersions from 'compare-versions';
const { makePersit } = MobXHelper;
import GlobalEvent from 'js-events-listener';

// const SHEET_API = field => "https://script.google.com/macros/s/AKfycbz2mwvpAYUjvP4c4qF00czzBM86ZM0_-cnI6-WlvKHQh9gSbn8/exec?field="+field;
const SERVER_API = field => `${HOST_SECOND}/utils/update-master-data?field_format=array&field=${field}`;
const SERVER_API_ALL = `${HOST_SECOND}/utils/update-master-data?field_format=array`;

class MasterStore  {
  constructor(isServer, initialData) {
    if(isServer) {
      for (let key in initialData) {
        this[key] = initialData[key];
      }
    } else {
      window.changeLang = this.changeLang;
      this.loadInitialData();
    }
  }

  @observable lang = 'en';

  @observable master_data_version = {};

  @observable contractor_type = {};
  @observable contractor_company_type = {};
  @observable contractor_sub_type = {};
  @observable contractor_quality_management = {};
  @observable contractor_affiliations = {};
  @observable project_type = {};
  @observable project_sub_type = {};
  @observable project_state = {};
  @observable project_state_status = {};
  @observable project_status = {};
  @observable project_work_type = {};
  @observable project_investment_type = {};
  @observable project_investment_type_app = {};
  @observable project_purpose = {};
  @observable project_budget = {};
  @observable project_construction_area = {};
  @observable project_land_area = {};
  @observable project_bidding_scope_name = {};
  @observable project_bidding_scope_works = {};
  @observable project_bidding_scope_materials = {};
  @observable product_categories = {};
  @observable product_sub_categories = {};
  @observable product_type = {};
  @observable project_company_role = {};
  @observable index_review_name = {};
  @observable index_review_content = {};
  @observable country = {};
  @observable city = {};
  @observable district = {};
  @observable product_categories_lev3 = {};
  @observable language = {};

  ready = false;

  loadInitialData = async () => {
    autorun(() => {
      makePersit.make(this.lang, "lang");
    });

    let master_data_version = await makePersit.persist("master_data_version", "object");
    if (master_data_version != undefined) this.master_data_version = master_data_version;
    const forced = await this.getMasterDataVersion();

    const arr = [
      "contractor_type", "contractor_company_type", "contractor_sub_type", "contractor_quality_management", "contractor_affiliations", "project_type", "project_sub_type",
      "project_state", "project_status", "project_state_status", "project_work_type", "project_investment_type", "project_investment_type_app", "project_purpose",
      "project_budget", "project_construction_area", "project_land_area", "product_categories", "product_sub_categories",
      "product_type", "project_company_role", "index_customer_review", "our_people", "country", "product_categories_lev3",
      "project_bidding scope_name", "project_bidding_scope_works", "project_bidding_scope_materials", 'project_bidding_scope_name',
      "city", "district", "language", "account_membership", "account_membership_detail",
    ];

    // for (let i = 0; i<arr.length; i++) {
    //   await this.syncDataByFieldName(arr[i], forced);
    // }
    await this.syncDataServer(arr, forced);
    this.ready = true;
    GlobalEvent.emit("FIELD_STORE_READY");
  };

  onReady = callback => new Promise((resolve, reject) => {
    const run = () => {
      typeof callback === 'function' && callback();
      resolve();
    };
    if (this.ready) run();
    else GlobalEvent.on("FIELD_STORE_READY", run);
  });

  findID = (fieldObject, fieldValue) => {
    let dataVi = fieldObject.vi;
    let dataEn = fieldObject.en;
    if (fieldObject.en === undefined) return "-1";
    let idArr = Object.keys(fieldObject.en);
    let length = idArr.length;
    for (let i=0; i<length; i++) {
      if(dataVi[idArr[i]] == fieldValue || dataEn[idArr[i]] == fieldValue) {
        return idArr[i];
      }
    }
    return "-1";
  };

  toTreeLevelData = (parentObject, childObject) => {
    if (parentObject == undefined || childObject == undefined) return [];
    /*
    [
      {
        id: "1", label: "", value:"", img: "", children: [
          { id: "1.1", label: "", value:"", img: "" }
        ]
      }
    ]
    */

    let result = [];

    let parent = parentObject.en;
    let parentImg = parentObject.img || {};
    let child = childObject.en;
    let childImg = childObject.img || {};
    if (parent == undefined || child == undefined) return [];

    let keyArrChild = Object.keys(child);

    for (let key in parent ) {
      let oneParent = { id: key, label: parent[key], value: parent[key], img: parentImg[key] };
      oneParent.children = [];
      let firstDotId = key + ".";
      keyArrChild.forEach(val => {
        if(val.indexOf(firstDotId) === 0) {
          oneParent.children.push({ id: val, label: child[val], value: child[val], img: childImg[val] })
        }
      });
      result.push(oneParent);
    }

    return result;

  };

  toSelectLabelObject = (fieldObject) => (valueOrId) => {
    // handle value first
    let dataEn = fieldObject.en;
    let dataVi = fieldObject.vi;
    for (let key in dataEn) {
      if(valueOrId === key) return { value: dataEn[key], label: fieldObject[this.lang][key] };
      if(dataEn[key] === valueOrId) return { value: dataEn[key], label: fieldObject[this.lang][key] };
      if(dataVi[key] === valueOrId) return { value: dataEn[key], label: fieldObject[this.lang][key] };
    }
  };

  toValue = (fieldObject, valueOrId) => {
    if(!fieldObject[this.lang]) return valueOrId;
    let data = VarHelper.valueBecameKey(fieldObject[this.lang]);
    // console.log(data);
    return data[valueOrId] || valueOrId;
  };

  toObject = (fieldObject) => {
    if(!fieldObject[this.lang]) return {};
    console.log('toObject', fieldObject[this.lang]);
    return fieldObject[this.lang];
  };

  toListWithImage = (fieldObject) => {
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let imgData = !!fieldObject.img ? fieldObject.img : {};
    let result = [];
    return Object.keys(data).map(item => ({ id: item, label: fieldObject.en[item], img: imgData[item], value: fieldObject.en[item] }));
  };

  toSelectData = (fieldObject) => {
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let result = [];
    return Object.keys(data).map(item => ({ id:item, value: fieldObject.en[item], label: data[item] }));
  };

  toSelectMoneyData = (fieldObject) => {
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let result = [];
    return Object.keys(data).map(item => ({ value: fieldObject.en[item], label: data[item].replace(/\,000\,000\,000\,000/g, ' nghìn tỷ').replace(/\,000\,000\,000/g, ' tỷ') }));
  };

  toSelectDataWithFilter = (firstDotId) => (fieldObject) => { // like "1.1", "1.2", filter all "1.*"
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let imgData = !!fieldObject.img ? fieldObject.img : {};
    return Object.keys(data).filter(item => item.indexOf(firstDotId) === 0).map(item => ({ id: item, value: fieldObject.en[item], label: data[item], img: imgData[item] }));
  };

  toSelectDataWithFilterId = (id) => {
    if (typeof id !== 'string') return this.toSelectDataWithFilter("");
    if (!id) return this.toSelectDataWithFilter("");
    return this.toSelectDataWithFilter(id.split(".")[0] + ".");
  };

  getMatchArray = (field) => {
    switch(field) {
      case 'project': return [
        { field: 'projectType', md: 'project_type' },
        { field: 'projectSubType', md: 'project_sub_type' },
        { field: 'purpose', md: 'project_purpose' },
        { field: 'investmentType', md: 'project_investment_type_app' },
        { field: 'workType', md: 'project_work_type' },
        { field: 'state', md: 'project_state' },
        { field: 'status', md: 'project_state_status' },
      ];

      case 'professional': return [
        { field: 'typeOfCompany', md: 'contractor_company_type' },
        { field: 'typeOfContractor', md: 'contractor_type' },
        { field: 'typeOfConstruction', md: 'contractor_sub_type' },
      ];

    }
  };

  convertValueToId = (matchArray) => (dataObject) => {
    // matchArray = [
    //   { field: 'purpose', md: this.project_purpose },
    // ];
    console.log(dataObject);
    let newDataObject = { ...dataObject };
    matchArray.forEach(val => {
      if (!val.field) return;
      const id = this.findID(this[val.md], newDataObject[val.field]);
      newDataObject[val.field] = id === "-1" ? newDataObject[val.field] : id;
    });
    return newDataObject;
  };

  getValueFromId = (fieldObject) => (id) => {
    if(!fieldObject[this.lang]) return id;
    let data = fieldObject[this.lang];
    console.log('getValueFromId', { id, value: fieldObject.en[id] || id, label: data[id] || id });
    return { id, value: fieldObject.en[id] || id, label: data[id] || id };
  };

  getMasterDataVersion = async () => {
    let res = await fetch(SERVER_API("master_data_version"));
    let json = await res.json();
    if (!json.result || !json.result[0]) return true;
    let forced = false;
    if (Object.keys(this.master_data_version).length === 0) {
      forced = true;
    } else if (compareVersions(json.result[0].en, this.master_data_version.en.version) > 0) {
      forced = true;
    }
    this.master_data_version = {
      en: {
        version: json.result[0].en
      },
      vi: {
        version: json.result[0].vi,
      }
    };
    makePersit.make(this.master_data_version, "master_data_version");
    return forced;
  }

  syncDataServer = async (arr, forced) => {
    if (forced === true) {
      const res = await fetch(SERVER_API_ALL);
      const json = await res.json();

      for (let i=0; i< arr.length; i++) {
        const fieldName = arr[i]
        this[fieldName] = (() => {
          let result = { en: {}, vi: {}, img: {} };
          if (!json.result.array[fieldName]) return result;
          json.result.array[fieldName].forEach((val, index) => {
            if (val.id === '') return;
            result.en[val.id] = val.en;
            result.vi[val.id] = val.vi;
            if (!!val.img) {
              result.img[val.id] = val.img;
            }
          });
          return result;
        })();

        makePersit.make(this[fieldName], fieldName);
      }
    } else {
      for (let i=0; i< arr.length; i++) {
        const fieldName = arr[i];
        let foo = await makePersit.persist(fieldName, "object");
        if (foo != undefined) this[fieldName] = foo;
      }
    }
  };
}

const masterStore = new MasterStore();
export default masterStore;




// WEBPACK FOOTER //
// ./src/services/master/Master.Store.js